import {
  Route, Routes,
} from '@angular/router';
import { ClientEditorDashboardPageComponent } from './pages/client-editor-dashboard-page/client-editor-dashboard-page.component';
import { ClientViewDashboardPageComponent } from './pages/client-view-dashboard-page/client-view-dashboard-page.component';
import { ChampionshipEditorDashboardPageComponent } from './pages/championship-editor-dashboard-page/championship-editor-dashboard-page.component';
import { ChampionshipsDashboardPageComponent } from './pages/championships-dashboard-page/championships-dashboard-page.component';
import { ChampionshipViewDashboardPageComponent } from './pages/championship-view-dashboard-page/championship-view-dashboard-page.component';
import { CalendarDashboardPageComponent } from './pages/calendar-dashboard-page/calendar-dashboard-page.component';
import { ClientsDashboardPageComponent } from './pages/clients-dashboard-page/clients-dashboard-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { ExpensesDashboardPageComponent } from './pages/expenses-dashboard-page/expenses-dashboard-page.component';
import { EventEditorDashboardPageComponent } from './pages/event-editor-dashboard-page/event-editor-dashboard-page.component';
import { EventViewDashboardPageComponent } from './pages/event-view-dashboard-page/event-view-dashboard-page.component';
import { EventsDashboardPageComponent } from './pages/events-dashboard-page/events-dashboard-page.component';
import { KanbanDashboardPageComponent } from './pages/kanban-dashboard-page/kanban-dashboard-page.component';
import { MailingsDashboardPageComponent } from './pages/mailings-dashboard-page/mailings-dashboard-page.component';
import { MinioDashboardPageComponent } from './pages/minio-dashboard-page/minio-dashboard-page.component';
import { NotificationsDashboardPageComponent } from './pages/notifications-dashboard-page/notifications-dashboard-page.component';
import { OrderEditorDashboardPageComponent } from './pages/order-editor-dashboard-page/order-editor-dashboard-page.component';
import { OrderViewDashboardPageComponent } from './pages/order-view-dashboard-page/order-view-dashboard-page.component';
import { OrdersDashboardPageComponent } from './pages/orders-dashboard-page/orders-dashboard-page.component';
import { ProfileDashboardPageComponent } from './pages/profile-dashboard-page/profile-dashboard-page.component';
import { SettlementsDashboardPageComponent } from './pages/settlements-dashboard-page/settlements-dashboard-page.component';
import { RegistrationPageComponent } from './pages/registration-page/registration-page.component';
import { SignInPageComponent } from './pages/sign-in-page/sign-in-page.component';
import { SeasonsDashboardPageComponent } from './pages/seasons-dashboard-page/seasons-dashboard-page.component';
import { TeamEditorDashboardPageComponent } from './pages/team-editor-dashboard-page/team-editor-dashboard-page.component';
import { TeamsDashboardPageComponent } from './pages/teams-dashboard-page/teams-dashboard-page.component';
import { TeamViewDashboardPageComponent } from './pages/team-view-dashboard-page/team-view-dashboard-page.component';
import { TelegramDashboardPageComponent } from './pages/telegram-dashboard-page/telegram-dashboard-page.component';
import { TicketsDashboardPageComponent } from './pages/tickets-dashboard-page/tickets-dashboard-page.component';
import { UsersDashboardPageComponent } from './pages/users-dashboard-page/users-dashboard-page.component';
import { WorkspaceSectionPageComponent } from './pages/workspace-section-page/workspace-section-page.component';

function createWorkspaceRoute(path: string, title: string, eyebrow: string, description: string): Route {
  return {
    path,
    title: `${title} | IcePass`,
    component: WorkspaceSectionPageComponent,
    data: {
      eyebrow,
      title,
      description,
      metrics: [
        {
          label: 'Статус',
          value: 'Скоро',
          tone: 'violet',
        },
        {
          label: 'Данные',
          value: '--',
          tone: 'blue',
        },
        {
          label: 'Модуль',
          value: '0%',
          tone: 'green',
        },
      ],
    },
  };
}

function createDashboardAlias(path: string, dashboardPath: string): Route {
  return {
    path,
    pathMatch: 'full',
    redirectTo: `/dashboard/${dashboardPath}`,
  };
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'registration',
    title: 'Регистрация | IcePass',
    component: RegistrationPageComponent,
  },
  {
    path: 'sign-in',
    title: 'Вход | IcePass',
    component: SignInPageComponent,
  },
  {
    path: 'dashboard',
    title: 'Аналитика | IcePass',
    component: DashboardPageComponent,
  },
  {
    path: 'dashboard/clients',
    title: 'Клиенты | IcePass',
    component: ClientsDashboardPageComponent,
  },
  {
    path: 'dashboard/clients/new',
    title: 'Новый клиент | IcePass',
    component: ClientEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/clients/:clientId/edit',
    title: 'Редактирование клиента | IcePass',
    component: ClientEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/clients/:clientId',
    title: 'Клиент | IcePass',
    component: ClientViewDashboardPageComponent,
  },
  {
    path: 'dashboard/directories',
    pathMatch: 'full',
    redirectTo: '/dashboard/teams',
  },
  {
    path: 'dashboard/teams',
    title: 'Команды | IcePass',
    component: TeamsDashboardPageComponent,
  },
  {
    path: 'dashboard/teams/new',
    title: 'Новая команда | IcePass',
    component: TeamEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/teams/:teamSlug/edit',
    title: 'Редактирование команды | IcePass',
    component: TeamEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/teams/:teamSlug',
    title: 'Команда | IcePass',
    component: TeamViewDashboardPageComponent,
  },
  {
    path: 'dashboard/championship',
    title: 'Чемпионаты | IcePass',
    component: ChampionshipsDashboardPageComponent,
  },
  {
    path: 'dashboard/championship/new',
    title: 'Новый чемпионат | IcePass',
    component: ChampionshipEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/championship/:championshipSlug/edit',
    title: 'Редактирование чемпионата | IcePass',
    component: ChampionshipEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/championship/:championshipSlug',
    title: 'Чемпионат | IcePass',
    component: ChampionshipViewDashboardPageComponent,
  },
  {
    path: 'dashboard/expenses',
    title: 'Расходы | IcePass',
    component: ExpensesDashboardPageComponent,
  },
  {
    path: 'dashboard/expenses/new',
    title: 'Новый расход | IcePass',
    component: ExpensesDashboardPageComponent,
  },
  {
    path: 'dashboard/expenses/:expenseId/edit',
    title: 'Редактирование расхода | IcePass',
    component: ExpensesDashboardPageComponent,
  },
  {
    path: 'dashboard/events',
    title: 'События | IcePass',
    component: EventsDashboardPageComponent,
  },
  {
    path: 'dashboard/events/new',
    title: 'Новое событие | IcePass',
    component: EventEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/events/:eventId/edit',
    title: 'Редактирование события | IcePass',
    component: EventEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/events/:eventId',
    title: 'Событие | IcePass',
    component: EventViewDashboardPageComponent,
  },
  createWorkspaceRoute('dashboard/crm', 'CRM', 'Работа с продажами', 'Воронка, задачи менеджеров и история коммуникаций по клиентам.'),
  {
    path: 'dashboard/tickets',
    title: 'Билеты | IcePass',
    component: TicketsDashboardPageComponent,
  },
  {
    path: 'dashboard/tickets/:eventId/add',
    title: 'Добавление билетов | IcePass',
    component: EventViewDashboardPageComponent,
  },
  {
    path: 'dashboard/tickets/:eventId',
    title: 'Билеты события | IcePass',
    component: EventViewDashboardPageComponent,
  },
  {
    path: 'dashboard/mailings',
    title: 'Рассылки | IcePass',
    component: MailingsDashboardPageComponent,
  },
  {
    path: 'dashboard/mailings/new',
    title: 'Новая рассылка | IcePass',
    component: MailingsDashboardPageComponent,
  },
  {
    path: 'dashboard/mailings/:mailingId/edit',
    title: 'Редактирование рассылки | IcePass',
    component: MailingsDashboardPageComponent,
  },
  {
    path: 'dashboard/kanban',
    title: 'Канбан | IcePass',
    component: KanbanDashboardPageComponent,
  },
  {
    path: 'dashboard/calendar',
    title: 'Календарь | IcePass',
    component: CalendarDashboardPageComponent,
  },
  {
    path: 'dashboard/settlements',
    title: 'Взаиморасчеты | IcePass',
    component: SettlementsDashboardPageComponent,
  },
  {
    path: 'dashboard/orders',
    title: 'Заказы | IcePass',
    component: OrdersDashboardPageComponent,
  },
  {
    path: 'dashboard/orders/new',
    title: 'Новый заказ | IcePass',
    component: OrderEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/orders/:orderId/edit',
    title: 'Редактирование заказа | IcePass',
    component: OrderEditorDashboardPageComponent,
  },
  {
    path: 'dashboard/orders/:orderId',
    title: 'Заказ | IcePass',
    component: OrderViewDashboardPageComponent,
  },
  {
    path: 'dashboard/season',
    title: 'Сезоны | IcePass',
    component: SeasonsDashboardPageComponent,
  },
  {
    path: 'dashboard/users',
    title: 'Пользователи | IcePass',
    component: UsersDashboardPageComponent,
  },
  {
    path: 'dashboard/notifications',
    title: 'Оповещения | IcePass',
    component: NotificationsDashboardPageComponent,
  },
  {
    path: 'dashboard/notifictions',
    redirectTo: '/dashboard/notifications',
  },
  createWorkspaceRoute('dashboard/settings', 'Настройки', 'Система', 'Права доступа, безопасность, токены API и параметры рабочего пространства.'),
  {
    path: 'dashboard/telegram',
    title: 'Telegram | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/accounts/new',
    title: 'Новый Telegram-аккаунт | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/accounts/:accountId/edit',
    title: 'Редактирование Telegram-аккаунта | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/bots/new',
    title: 'Новый Telegram-бот | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/bots/:botId/edit',
    title: 'Редактирование Telegram-бота | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/parsers/new',
    title: 'Новый Telegram-парсер | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/telegram/parsers/:parserId/edit',
    title: 'Редактирование Telegram-парсера | IcePass',
    component: TelegramDashboardPageComponent,
  },
  {
    path: 'dashboard/minio',
    title: 'MinIO | IcePass',
    component: MinioDashboardPageComponent,
  },
  createWorkspaceRoute('dashboard/bank', 'Банк', 'Интеграции', 'Подключение банковских операций и платежных уведомлений.'),
  {
    path: 'dashboard/profile',
    title: 'Профиль | IcePass',
    component: ProfileDashboardPageComponent,
  },
  createDashboardAlias('events', 'events'),
  createDashboardAlias('tickets', 'tickets'),
  createDashboardAlias('clients', 'clients'),
  createDashboardAlias('mailings', 'mailings'),
  createDashboardAlias('kanban', 'kanban'),
  createDashboardAlias('calendar', 'calendar'),
  createDashboardAlias('settlements', 'settlements'),
  createDashboardAlias('orders', 'orders'),
  createDashboardAlias('expenses', 'expenses'),
  createDashboardAlias('teams', 'teams'),
  createDashboardAlias('championship', 'championship'),
  createDashboardAlias('season', 'season'),
  createDashboardAlias('users', 'users'),
  createDashboardAlias('notifications', 'notifications'),
  createDashboardAlias('notifictions', 'notifications'),
  createDashboardAlias('settings', 'settings'),
  createDashboardAlias('telegram', 'telegram'),
  createDashboardAlias('minio', 'minio'),
  createDashboardAlias('bank', 'bank'),
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
